import React from 'react';
import { PackMeta, SmartActionBtn, SortTh } from './StockPrimitives';

const DeadStockTab = ({ deadStock, filtered, openActions, addressedActions, skippedActions, onOpenAction, deadStockDays, deadSort, setDeadSort }) => {
  const rows = filtered(deadStock, 'product_name');
  const total = rows.reduce((sum, item) => sum + Number(item.holding_cost || 0), 0);

  const sorted = [...rows].sort((a, b) => {
    let av, bv;
    switch (deadSort.col) {
      case 'product_name':  av = (a.product_name || '').toLowerCase(); bv = (b.product_name || '').toLowerCase(); break;
      case 'stock':         av = a.stock ?? -Infinity; bv = b.stock ?? -Infinity; break;
      case 'cost_price':    av = a.cost_price ?? -Infinity; bv = b.cost_price ?? -Infinity; break;
      case 'holding_cost':  av = a.holding_cost ?? -Infinity; bv = b.holding_cost ?? -Infinity; break;
      default:              av = 0; bv = 0;
    }
    if (av < bv) return deadSort.dir === 'asc' ? -1 : 1;
    if (av > bv) return deadSort.dir === 'asc' ? 1 : -1;
    return 0;
  });

  const fmtLastSold = (item) => {
    const days = item.days_since_last_sale;
    if (days == null) return '—';
    return item.is_approximate_days ? `${days}+ d ago` : `${days}d ago`;
  };

  return (
    <>
      {deadStock.length > 0 && (
        <div className="px-4 py-3 bg-amber-50 border-b border-amber-100 text-sm flex items-center gap-4 flex-wrap">
          <span>
            Total capital blocked:{' '}
            <span className="font-semibold text-amber-700">₹{total.toLocaleString('en-IN')}</span>
          </span>
          <span className="text-muted-foreground/60">·</span>
          <span className="text-muted-foreground">
            No sales in last <span className="font-medium text-amber-700">{deadStockDays}</span> days
          </span>
        </div>
      )}
      <div className="overflow-x-auto w-full">
      <table className="w-full min-w-[520px] text-sm">
        <thead>
          <tr className="border-b border-border text-muted-foreground text-xs uppercase tracking-wide">
            <SortTh col="product_name" label="Product"         sort={deadSort} setSort={setDeadSort} />
            <SortTh col="stock"        label="Stock"           sort={deadSort} setSort={setDeadSort} right />
            <SortTh col="cost_price"   label="Avg Buy"         sort={deadSort} setSort={setDeadSort} right />
            <SortTh col="holding_cost" label="Capital Blocked" sort={deadSort} setSort={setDeadSort} right />
            <th className="text-right py-3 px-4 whitespace-nowrap">Last Sold</th>
            <th className="py-3 px-4" />
          </tr>
        </thead>
        <tbody>
          {sorted.map((item, i) => (
            <tr key={i} className="border-b border-border last:border-0 hover:bg-muted/30">
              <td className="py-3 px-4">
                <span className="font-medium">{item.product_name}</span>
                <div className="mt-0.5"><PackMeta packSize={item.pack_size} unit={item.unit} /></div>
              </td>
              <td className="py-3 px-4 text-right">{item.stock}</td>
              <td className="py-3 px-4 text-right">
                {item.cost_price != null ? `₹${Number(item.cost_price).toFixed(2)}` : '—'}
              </td>
              <td className="py-3 px-4 text-right font-semibold text-amber-600">
                {item.holding_cost != null ? `₹${Number(item.holding_cost).toLocaleString('en-IN', { maximumFractionDigits: 2 })}` : '—'}
              </td>
              <td className="py-3 px-4 text-right text-muted-foreground text-xs">{fmtLastSold(item)}</td>
              <td className="py-3 px-4 text-right">
                <SmartActionBtn catalogId={item.catalog_id} productName={item.product_name} openActions={openActions} addressedActions={addressedActions} skippedActions={skippedActions} onOpenAction={onOpenAction} />
              </td>
            </tr>
          ))}
          {sorted.length === 0 && (
            <tr><td colSpan={6} className="py-8 text-center text-muted-foreground">No dead stock found</td></tr>
          )}
        </tbody>
      </table>
      </div>
    </>
  );
};

export default DeadStockTab;
